module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDEiIGhlaWdodD0iNjEiIHZpZXdCb3g9IjAgMCA0MSA2MSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI2LjU5MzQgMC45NDY3ODNMMC43NDA2MDEgMC45NDY3NzdMMTQuMjYxMSAzMC44OTlMMC43NDA1OTIgNjAuODQxOEwyNi41OTM0IDYwLjg0MThMNDAuMTEzOSAzMC44OTlMMjYuNTkzNCAwLjk0Njc4M1oiIGZpbGw9IndoaXRlIiBmaWxsLW9wYWNpdHk9IjAuMSIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/flash-arrow-right.svg
// module id = wxpA
// module chunks = 13